if (!String.prototype.compare) {
    String.prototype.compare = function (str) {
        return this.localeCompare(str)
    }
}

if (!String.prototype.splitOnIndex) {
    String.prototype.splitAtIndex = function (index) {
        return [this.slice(0, index), this.slice.slice(index)]
    }
}

if (!String.prototype.contains) {
    String.prototype.contains = function (search) {
        return this.includes(search, 0)
    }
}

if (!String.prototype.compareIgnore) {
    String.prototype.compareIgnore = function (str) {
        return this.localeCompare(str, 'en', { sensitivity: 'base' })
    }
}

if (!String.prototype.formatCurrency) {
    String.prototype.formatCurrency = function () {
        return Number(this).formatCurrency()
    }
}

if (!String.prototype.capitalize) {
    String.prototype.capitalize = function () {
        var words = this.split(/\s+/)
        var capitalized_array = words
            .where((w) => !!w)
            .map((word) => {
                return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
            })
        return capitalized_array.join(' ')
    }
}

if (!String.prototype.toKebabCase) {
    String.prototype.toKebabCase = function () {
        return this.split('')
            .map((letter, idx) => {
                return letter.toUpperCase() === letter
                    ? `${idx !== 0 ? '-' : ''}${letter.toLowerCase()}`
                    : letter
            })
            .join('')
    }
}

if (!String.prototype.toPascalCase) {
    String.prototype.toPascalCase = function () {
        return this.split('-')
            .map((word) => {
                if (!word) {
                    return ''
                }
                return word.charAt(0).toUpperCase() + word.slice(1)
            })
            .join('')
    }
}
